import api from '../../../services/dealer/axios';

async function getOrderDetailDms(params) {
  const { data } = await api.get('orderDetail', {
    params,
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });

  return data.data;
}

/**
 * Retrieves list of orders with main props.
 *
 * @param {Object} params - The parameters for fetching orders.
 * @param {string} params.superOrderIdDms - The DMS superorder identifier.
 * @param {string} params.email - The email associated with the order.
 * @param {string} params.dealerId - The dealer identifier.
 *
 * @returns {Promise<Object>} A promise that resolves to the order data.
 */
async function getOrders({ superOrderIdDms, email, dealerId }) {
  const { data } = await api.get('status-order', {
    params: {
      orderId: superOrderIdDms,
      email,
      dealerId,
    },
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
    },
  });

  return data.data;
}

export default function createApiOrderRepository() {
  return {
    getOrderDetailDms,
    getOrders,
  };
}
